import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import Typography from '@mui/joy/Typography'
import { Link } from 'react-router-dom'

export const ProgressError = ({ msg, path }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                gap: 1,
            }}
        >
            <Typography level="body-lg" color="neutral">
                {msg}
            </Typography>
            <Box>
                <Link to={path} reloadDocument>
                    <Button
                        sx={{ minWidth: 100 }}
                        variant="solid"
                        color="primary"
                    >
                        OK
                    </Button>
                </Link>
            </Box>
        </Box>
    )
}
